import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import TenantConsole from "@/pages/TenantConsole";
import AdminConsole from "@/pages/admin/AdminConsole";
import SecurityOverview from "@/pages/SecurityOverview";
import Welcome from "@/pages/avi/Welcome";
import AviChat from "@/pages/avi/AviChat";
import AviSettings from "@/pages/avi/Settings";
import AuthCallback from "@/pages/avi/AuthCallback";

function RoutedApp() {
  const location = useLocation();
  // Emergent Google OAuth returns with #session_id=... — must be handled first
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/console" element={<TenantConsole />} />
      <Route path="/admin" element={<AdminConsole />} />
      <Route path="/security" element={<SecurityOverview />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/app" element={<AviChat />} />
      <Route path="/app/settings" element={<AviSettings />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RoutedApp />
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
